import { Injectable } from '@angular/core';

@Injectable()
export class ScrollToAnchorService {

  constructor() { }


  public scroll(elementId) : void {
    if (elementId) {
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }

}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/scroll-to-anchor.service.ts